"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillContentWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var useFillContentWrapperStyles = (0, react_jss_1.createUseStyles)({
    fillContentWrapper: {
        height: "100%",
        width: "100%",
        "& > *": {
            height: "100%",
            width: "100%",
        },
    },
});
var FillContentWrapper = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var classes = useFillContentWrapperStyles();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(classes.fillContentWrapper, " ").concat(className !== null && className !== void 0 ? className : "") }, props, { children: children })));
};
exports.FillContentWrapper = FillContentWrapper;
//# sourceMappingURL=FillContentWrapper.js.map